import React, {useState, useEffect} from 'react';

//import {Modal, Button} from 'react-bootstrap';

//import 'bootstrap/dist/css/bootstrap.min.css';

const InvitationModal = ({toggleShow, btnClose, btnCallerInvite, inputEmail, txtemail, btninvitespin}) =>{

    //const [show, setShow] = useState(false);
    

    return(
    
    <div className={toggleShow ? 'modal fade show' : 'modal fade' } id="inviteCallerModal" tabindex="-1" aria-labelledby="inviteCallerModal" data-bs-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content crm-modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="staticBackdropLabel2">Invite Caller</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={btnClose}></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label htmlFor="email" className="form-label">Email*</label>
                        <input className="form-control" type="email" id="email" name="email" value={txtemail} required="" placeholder="Enter email address" onChange={inputEmail} />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={btnClose}>Close</button>

                    {btninvitespin ?
                        <button type="button" class="btn btn-primary">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </button>
                    :
                        <button type="button" class="btn btn-primary" onClick={btnCallerInvite}> Delete </button>
                    }
                </div>
            </div>
        </div>
    </div>
    );
}

export default InvitationModal;
